import {mapGetters, mapState} from 'vuex'
import {ApiUtils} from "@/utils/ApiUtils";

export default {
    data(){
        return {
            savingSettings: false
        }
    },
    computed:{
        ...mapGetters(['currentProviderSettings']),
        ...mapState(['currentProvider']),
        canCreateLabels(){
          const vm = this
            return vm.currentProviderSettings
                && vm.currentProviderSettings.allow_label_creation
        },
        useLabelsOnAppointments(){
            const vm = this
            return vm.currentProviderSettings
            && vm.currentProviderSettings.allow_labels_on_appointments
        },
    },
    methods:{
        async saveSettings(payload){
            const vm = this
            if(vm.savingSettings || !vm.currentProvider) return

            const { id } = vm.currentProvider

            vm.savingSettings = true
            const response = await ApiUtils.makePatch(`provider/${id}/settings`, null, payload)

            if (response.ok) {
                await ApiUtils.fetchMe()
                vm.savingSettings = false
                return true
            }

            vm.savingSettings = false
            return false
        }
    }
}
